import _ from "lodash";
import { ADD_FILTER, CLEAR_FILTER, REMOVE_FILTER } from "../constants";

export const INITIAL_STATE: any = {};

export default (
  state = INITIAL_STATE,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case ADD_FILTER: {
      const { target, filterName, filterValue } = payload;
      // Get current filters.
      const filters = _.cloneDeep(_.get(state, target, {}));
      // Depending on our filter name, update the value in our object.
      _.set(filters, filterName, filterValue);
      return { ...state, [target]: filters };
    }
    case REMOVE_FILTER: {
      const { target, filterName } = payload;
      // Get current filters.
     const filters = _.cloneDeep(_.get(state, target, {}));
      // Depending on our filter name, update the value in our object.
      _.set(filters, filterName, []);
      return { ...state, [target]: filters };
    }
    case CLEAR_FILTER: {
      const { target } = payload;
      return { ...state, [target]: {} };
    }
    default:
      return state;
  }
};
